import { apiSlice } from './apiSlice';

export const shotDataApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getShotData: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = '',
        sort = 'createdAt',
        order = 'desc',
      }) => ({
        url: 'shots',
        params: { page, limit, search, sort, order },
      }),
      transformResponse: (response) => ({
        entries: response.entries || [],
        total: response.total || 0,
        page: response.page || 1,
        pages: response.pages || 1,
      }),
      providesTags: (result) =>
        result?.entries?.length
          ? [
              ...result.entries.map((entry) => ({
                type: 'ShotData',
                id: entry._id,
              })),
              { type: 'ShotData', id: 'LIST' },
            ]
          : [{ type: 'ShotData', id: 'LIST' }],
    }),

    getShotsByGameId: builder.query({
      query: ({gameId, limit=0, page=1, sort= "gameTimeSeconds", order = 1, search=""}={}) => ({
        url: `shots/game/${gameId}`,
        params: {limit, page, sort, order, search}
      }),
      providesTags: [{type: "ShotData", id: "LIST"}]
     
    }),

    getPlayerSummary: builder.query({
      query: ({ team = '', limit = 10, page = 1, sort = 'player', order = 1, search = '' } = {}) => ({
        url: 'shots/summary/players',
        params: { limit, page, sort, order, search },
      }),
    }),

    createShotData: builder.mutation({
      query: (data) => ({
        url: 'shots',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'ShotData', id: 'LIST' }],
    }),

    updateShotData: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `shots/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: [{ type: 'ShotData', id: 'LIST' }],
    }),

    deleteShotData: builder.mutation({
      query: (id) => ({
        url: `shots/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'ShotData', id: 'LIST' }],
    }),

    getPlayerGamesStats: builder.query({
    query: ({ playerName, page = 1, limit = 10, search = '', sort = "gameDate", order = -1 }) => ({
        url: `shots/players/${playerName}/games`,
        params: { page, limit, search, sort, order },
    }),
    transformResponse: (response) => response ?? [],
    providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map((game) => ({
                type: 'ShotData',
                id: game.gameId,
              })),
              { type: 'ShotData', id: 'GAMES' },
            ]
          : [{ type: 'ShotData', id: 'GAMES' }],
    }),
  }),
});

export const {
  useGetShotDataQuery,
  useGetShotsByGameIdQuery,
  useGetPlayerSummaryQuery,
  useCreateShotDataMutation,
  useUpdateShotDataMutation,
  useDeleteShotDataMutation,
  useGetPlayerGamesStatsQuery,
} = shotDataApiSlice;
